import React from 'react';
import { GameState } from "../../../../../services/api";
import NumberPanel from '../../../../Common/NumberPanel';
import SituationPanel from '../../../../Common/SituationPanel';

interface ActingPlayerViewProps {
  gameState: GameState;
}

const ActingPlayerView: React.FC<ActingPlayerViewProps> = ({ gameState }) => {
  return (
    <div className="flex flex-col items-center space-y-6 max-w-2xl mx-auto">
      <NumberPanel 
        number={gameState.assignedNumber}
        maxNumber={gameState.players.length-1}
        variant="primary" />
      {gameState.state === "acting" && <SituationPanel situation={gameState.currentSituation} variant="basic" />}
    </div>
  );
};

export default ActingPlayerView;